<template>
    <div v-if="hasImage" v-editable="blok" class="l4-image" :class="contentClass">
        <LazyDynamicImage :blok="blok" native :width="1800" />
    </div>
</template>

<script setup lang="ts">
import type { IL4Image } from '~/types/components/L4Image';

const { blok } = defineProps<{ blok: IL4Image }>();

const hasImage = computed(() => blok.image?.filename && blok.image.filename.length > 0);
const contentClass = computed(() => `${blok.vertical_align ? `flex items-${blok.vertical_align}` : ``}`);
</script>

<style lang="postcss" scoped>
.l4-image {
    font-size: 0;
    :deep(img) {
        @apply w-full block;
    }
}
</style>
